import * as z from 'zod';
import * as ba from './base';
import { assertComponentContext } from '../helpers';
export class FormAction extends ba.Action {
    static get manifest() {
        return {
            name: 'form',
            schema: z.object({
                name: z.string(),
                reset: z.boolean().optional()
            })
        };
    }
    async handle(event, args) {
        const component = event.component;
        assertComponentContext(component);
        const form = component.forms[args.name];
        if (form && args.reset) {
            form.reset();
        }
    }
}
//# sourceMappingURL=form.js.map